import { useEffect, useState } from "react";
import { Building2, Mail, Phone, RefreshCw, Trash2 } from "lucide-react";
import { apiDeleteLead, apiGetLeads } from "@/admin/adminApi";

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch (err) {
    return iso;
  }
};

const LeadsTab = () => {
  const [leads, setLeads] = useState(null);
  const [message, setMessage] = useState("");

  const load = () => {
    apiGetLeads()
      .then((res) => setLeads(res.data))
      .catch(() => setMessage("Could not load leads"));
  };

  useEffect(load, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this lead? This cannot be undone.")) {
      return;
    }
    try {
      await apiDeleteLead(id);
      setLeads((prev) => prev.filter((lead) => lead.id !== id));
      setMessage("Lead deleted");
    } catch (err) {
      setMessage("Delete failed");
    }
  };

  if (!leads) {
    return <p className="af-hint-block">Loading leads...</p>;
  }

  return (
    <div data-testid="admin-tab-content-leads">
      <div className="af-media-toolbar">
        <button type="button" className="af-btn" onClick={load} data-testid="admin-leads-refresh-btn">
          <RefreshCw size={13} />
          Refresh
        </button>
        <span className="af-hint">
          {leads.length === 1 ? "1 message" : `${leads.length} messages`} from the website contact form, newest first.
        </span>
        {message && <span className="af-media-message">{message}</span>}
      </div>

      {leads.length === 0 ? (
        <p className="af-hint-block" data-testid="admin-leads-empty">
          No messages yet. Contact form submissions will appear here.
        </p>
      ) : (
        <div className="af-leads" data-testid="admin-leads-list">
          {leads.map((lead) => (
            <div className="af-lead-card" key={lead.id} data-testid={`admin-lead-${lead.id}`}>
              <div className="af-lead-head">
                <span className="af-lead-name">{lead.name}</span>
                <span className="af-lead-date">{formatDate(lead.created_at)}</span>
              </div>
              <div className="af-lead-contacts">
                <a className="af-lead-chip" href={`mailto:${lead.email}`}>
                  <Mail size={11} />
                  {lead.email}
                </a>
                {lead.phone && (
                  <span className="af-lead-chip">
                    <Phone size={11} />
                    {lead.phone}
                  </span>
                )}
                {lead.company && (
                  <span className="af-lead-chip">
                    <Building2 size={11} />
                    {lead.company}
                  </span>
                )}
              </div>
              <p className="af-lead-message">{lead.message}</p>
              <div className="af-lead-actions">
                <button
                  type="button"
                  className="af-btn af-btn-danger"
                  onClick={() => handleDelete(lead.id)}
                  data-testid={`admin-lead-delete-${lead.id}`}
                >
                  <Trash2 size={12} />
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeadsTab;
